import React from 'react'
import Row from '../shared/ui/row'
import Col from '../shared/ui/col'
import Text from '../shared/ui/text'
import Box from '../shared/ui/box'
import ReactHtmlParser from 'react-html-parser'
import Moment from 'moment'
import Dimensions from 'react-dimensions'

class EventDetails extends React.Component<any, any> {
  formatUrl(url) {
    const httpString = 'http://'
    const httpsString = 'https://'
    if (
      url.substr(0, httpString.length).toLowerCase() !== httpString &&
      url.substr(0, httpsString.length).toLowerCase() !== httpsString
    ) {
      url = httpString + url
    }
    return url
  }

  renderEventDetails() {
    return (
      <Box css={{ width: '100%', margin: 'auto' }}>
        <Box direction={['column', 'row']}>
          {this.props.is_ongoing === true ? (
            <div />
          ) : (
              <Row wrap>
                <Col size={[12, 3]}>
                  <Text is="h4">Date</Text>
                </Col>
                <Col size={[12, 9]}>
                  {this.props.end_date &&
                    this.props.start_date !== this.props.end_date ? (
                      <Text>
                        {Moment(this.props.start_date).format('DD MMMM YYYY') +
                          ' - ' +
                          Moment(this.props.end_date).format('DD MMMM YYYY')}
                      </Text>
                    ) : (
                      <Text>
                        {Moment(this.props.start_date).format('DD MMMM YYYY')}
                      </Text>
                    )}
                </Col>
              </Row>
            )}
          {this.props.venue && this.props.venue.length > 0 ? (
            <Row wrap>
              <Col size={[12, 3]}>
                <Text is="h4">Venue</Text>
              </Col>
              <Col size={[12, 9]}>
                <Text>{this.props.venue}</Text>
              </Col>
            </Row>
          ) : (
              <div />
            )}
          <Row wrap>
            <Col size={[12, 3]}>
              <Text is="h4">Location</Text>
            </Col>
            <Col size={[12, 9]}>
              <Text>
                {`${this.props.city}, ${
                  this.props.province === 'AP'
                    ? 'All Provinces'
                    : this.props.province
                  }`}
              </Text>
            </Col>
          </Row>
          <Row wrap>
            <Col size={[12, 3]}>
              <Text is="h4">Contact</Text>
            </Col>
            <Col size={[12, 9]}>
              <Text>{this.props.contact_name}</Text>
            </Col>
          </Row>
          <Row wrap>
            <Col size={[12, 3]}>
              <Text is="h4">Email</Text>
            </Col>
            <Col size={[12, 9]}>
              <Text is="a" href={`mailto:${this.props.email}`}>
                {this.props.email}
              </Text>
            </Col>
          </Row>
          <Row wrap>
            <Col size={[12, 3]}>
              <Text is="h4">Website</Text>
            </Col>
            <Col size={[12, 9]}>
              <Text
                is="a"
                href={this.formatUrl(this.props.url)}
                target="_blank"
              >
                {this.props.url}
              </Text>
            </Col>
          </Row>
          <Row wrap>
            <Col size={[12, 3]}>
              <Text is="h4">Volunteers needed</Text>
            </Col>
            <Col size={[12, 9]}>
              <Text>{this.props.volunteers_needed ? ' Yes ' : ' No '}</Text>
            </Col>
          </Row>
          <Row wrap>
            <Col size={[12, 3]}>
              <Text is="h4">Description</Text>
            </Col>
            <Col size={[12, 9]}>
              <Text>{ReactHtmlParser(this.props.description)}</Text>
              {this.props.event_code ? (
                <Text
                  is="a"
                  href={`http://www.cdha.ca/CDHA/EventDisplay?EventKey=${
                    this.props.event_code
                    }`}
                >
                  Register Now
                </Text>
              ) : (
                  <div />
                )}
            </Col>
          </Row>
        </Box>
      </Box>
    )
  }

  render() {
    return this.renderEventDetails()
  }
}

export default Dimensions()(EventDetails)
